import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  getBasicInfoFailure,
  getBasicInfoSuccess,
  updateBasicInfoFailure,
  updateBasicInfoSuccess,
  getUserAccountInfoFailure,
  getUserAccountInfoSuccess,
  updateUserAccountInfoFailure,
  updateUserAccountInfoSuccess,
  getEmploymentInfoFailure,
  getEmploymentInfoSuccess,
  updateEmploymentInfoFailure,
  updateEmploymentInfoSuccess,
  getPermissionsSuccess,
  getPermissionsFailure,
  updatePermissionsSuccess,
  updatePermissionsFailure,
  getLineInfoFailure,
  getLineInfoSuccess,
  updateLineInfoFailure,
  updateLineInfoSuccess,
  getWorkingInfoFailure,
  getWorkingInfoSuccess,
  updateWorkingInfoFailure,
  updateWorkingInfoSuccess,
  getRoleInfoFailure,
  getRoleInfoSuccess,
  updateRoleInfoFailure,
  updateRoleInfoSuccess,
  getWorkingLocationsFailure,
  getWorkingLocationsSuccess,
  updateLocationsFailure,
  updateLocationsSuccess,
  getOnboardingStepsFailure,
  getOnboardingStepsSuccess,
  getStepDetailsFailure,
  getStepDetailsSuccess,
  approveFieldFailure,
  approveFieldSuccess,
  getPersonalInfoFailure,
  getPersonalInfoSuccess,
  updatePersonalInfoFailure,
  updatePersonalInfoSuccess,
  getDocumentsFailure,
  getDocumentsSuccess,
  getHolidayInfoFailure,
  getHolidayInfoSuccess,
  getLeavesFailure,
  getLeavesSuccess,
  updateHolidayInfoFailure,
  updateHolidayInfoSuccess,
  getPayrollInfoFailure,
  getPayrollInfoSuccess,
  updatePayrollInfoFailure,
  updatePayrollInfoSuccess,
  downloadFileFailure,
  downloadFileSuccess,
  deleteFileFailure,
  deleteFileSuccess,
  getVersionHistoryFailure,
  getVersionHistorySuccess,
  sendRevisionMailFailure,
  sendRevisionMailSuccess,
  getDocVersionsFailure,
  getDocVersionsSuccess,
  sendDocMailFailure,
  sendDocMailSuccess,
  getDocCorrectionsFailure,
  getDocCorrectionsSuccess,
  uploadNewDocFailure,
  uploadNewDocSuccess,
  getStepHistoryFailure,
  getStepHistorySuccess,
  getAdditionalDocumentsFailure,
  getAdditionalDocumentsSuccess,
  getDocsHistoryFailure,
  getDocsHistorySuccess,
  editVersionFileFailure,
  editVersionFileSuccess,
} from "./actions";
import {
  GET_BASIC_INFO,
  UPDATE_BASIC_INFO,
  GET_USER_ACCOUNT_INFO,
  UPDATE_USER_ACCOUNT_INFO,
  GET_EMPLOYEEMENT_INFO,
  UPDATE_EMPLOYEEMENT_INFO,
  GET_PERMISSIONS,
  UPDATE_PERMISSIONS,
  GET_LINE_INFO,
  UPDATE_LINE_INFO,
  GET_WORKING_INFO,
  UPDATE_WORKING_INFO,
  GET_ROLE_INFO,
  UPDATE_ROLE_INFO,
  GET_WORKING_LOCATIONS,
  UPDATE_LOCATIONS,
  GET_ONBOARDING_STEPS,
  GET_STEP_DETAILS,
  APPROVE_FIELD,
  GET_PERSONAL_INFO,
  UPDATE_PERSONAL_INFO,
  GET_DOCUMENTS,
  GET_HOLIDAY_INFO,
  GET_LEAVES,
  UPDATE_HOLIDAY_INFO,
  GET_PAYROLL_INFO,
  UPDATE_PAYROLL_INFO,
  DOWNLOAD_FILE,
  DELETE_FILE,
  GET_VERSION_HISTORY,
  SEND_REVISION_MAIL,
  GET_DOC_VERSIONS,
  SEND_DOC_MAIL,
  GET_DOC_CORRECTIONS,
  UPLOAD_NEW_DOC,
  GET_STEP_HISTORY,
  GET_ADDITIONAL_DOCUMENTS,
  GET_DOCS_HISTORY,
  EDIT_VERSION_FILE,
} from "./constants";
import QueryString from "query-string";

export function* getBasicInfoSaga({ payload, callback }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/employee/get-basic-info/${payload}`,
    );
    yield put(getBasicInfoSuccess(data));
    typeof callback === "function" && callback(data);
  } catch (e) {
    yield put(getBasicInfoFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* updateBasicInfoSaga({ payload, callback }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/employee/update-basic-info/${payload?.id}`,
      payload?.data,
    );
    yield put(updateBasicInfoSuccess());
    yield put(successAlert("Basic info updated successfully!"));
    if (callback) callback();
  } catch (e) {
    yield put(updateBasicInfoFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while updating data!"));
  }
}

export function* getUserAccountInfoSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/employee/get-user-account-info/${payload}`,
    );
    yield put(getUserAccountInfoSuccess(data));
  } catch (e) {
    yield put(getUserAccountInfoFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching user info!"));
  }
}

export function* updateUserAccountInfoSaga({ payload, callback }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/employee/update-user-account-info`,
      payload,
    );
    yield put(updateUserAccountInfoSuccess(data));
    yield put(successAlert("User info updated successfully!"));
    if (callback) callback(data);
  } catch (e) {
    yield put(updateUserAccountInfoFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while updating user info!"));
  }
}

export function* getEmploymentInfoSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/employee/get-employment-details/${payload}`,
    );
    yield put(getEmploymentInfoSuccess(data));
  } catch (e) {
    yield put(getEmploymentInfoFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* updateEmploymentInfoSaga({ payload, callback }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/employee/update-employment-details/${payload?.id}`,
      payload?.data,
    );
    yield put(updateEmploymentInfoSuccess());
    yield put(successAlert("Employment info updated successfully!"));
    yield put(getEmploymentInfoSuccess(data));
    if (callback) callback();
  } catch (e) {
    yield put(updateEmploymentInfoFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while updating data!"));
  }
}

export function* getPermissionsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/employee/get-permission-info/${payload}`,
    );
    yield put(getPermissionsSuccess(data, payload));
  } catch (e) {
    yield put(getPermissionsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* updatePermissionsSaga({ payload, callback }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/employee/update-permission-info`,
      payload,
    );
    yield put(updatePermissionsSuccess());
    yield put(successAlert("Permissions updated successfully!"));
    if (callback) callback(data);
  } catch (e) {
    yield put(updatePermissionsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while updating data!"));
  }
}

export function* getLineInfoSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/employee/get-line-management/${payload}`,
    );
    yield put(getLineInfoSuccess(data));
  } catch (e) {
    yield put(getLineInfoFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* updateLineInfoSaga({ payload, callback }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/employee/update-line-management/${payload?.id}`,
      payload?.data,
    );
    yield put(updateLineInfoSuccess());
    yield put(successAlert("Line info updated successfully!"));
    yield put(getLineInfoSuccess(data));
    if (callback) callback();
  } catch (e) {
    yield put(updateLineInfoFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while updating data!"));
  }
}

export function* getWorkingInfoSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/employee/get-work-schedule/${payload}`,
    );
    yield put(getWorkingInfoSuccess(data));
  } catch (e) {
    yield put(getWorkingInfoFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* updateWorkingInfoSaga({ payload, callback }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/employee/update-work-schedule`,
      payload,
    );
    yield put(updateWorkingInfoSuccess());
    yield put(successAlert("Working info updated successfully!"));
    if (callback) callback(data);
  } catch (e) {
    yield put(updateWorkingInfoFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while updating data!"));
  }
}

export function* getRoleInfoSaga({ payload, callback }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/employee/get-role-assign/${payload}`,
    );
    yield put(getRoleInfoSuccess(data));
    typeof callback === "function" && callback(data);
  } catch (e) {
    yield put(getRoleInfoFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* updateRoleInfoSaga({ payload, callback }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/employee/update-role-assign`,
      payload,
    );
    yield put(updateRoleInfoSuccess());
    yield put(successAlert("Roles updated successfully!"));
    yield put(getRoleInfoSuccess(data));
    if (callback) callback();
  } catch (e) {
    yield put(updateRoleInfoFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while updating data!"));
  }
}

export function* getWorkingLocationsSaga({ payload, callback }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/employee/get-work-location/${payload}`,
    );
    yield put(getWorkingLocationsSuccess(data));
    typeof callback === "function" && callback(data);
  } catch (e) {
    yield put(getWorkingLocationsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* updateLocationsSaga({ payload, callback }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/employee/update-work-location`,
      payload,
    );
    yield put(updateLocationsSuccess());
    yield put(successAlert("Locations updated successfully!"));
    yield put(getWorkingLocationsSuccess(data));
    if (callback) callback();
  } catch (e) {
    yield put(updateLocationsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while updating data!"));
  }
}

export function* getOnboardingStepsSaga({ payload, onGet }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/hr/onboarding/step/${payload}`,
    );
    yield put(getOnboardingStepsSuccess(data));
    typeof onGet === "function" && onGet(data);
  } catch (e) {
    yield put(getOnboardingStepsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* getStepDetailsSaga({ payload, callback }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/hr/onboarding/${payload.employeeId}/step`,
    );
    yield put(getStepDetailsSuccess(data));
    if (callback) callback(data);
  } catch (e) {
    yield put(getStepDetailsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* approveFieldSaga({ payload, callback }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { isApprovingStep, employeeId, formData } = payload;
  try {
    const { data } = yield call(
      api(token).post,
      isApprovingStep
        ? `/api/hr/onboarding/step-validation`
        : `/api/hr/onboarding/${employeeId}/save-response-status`,
      formData,
    );
    yield put(approveFieldSuccess());
    if (callback) callback(data);
  } catch (e) {
    yield put(approveFieldFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while approving field!"));
  }
}

export function* getPersonalInfoSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/employee/get-personal-info/${payload}`,
    );
    yield put(getPersonalInfoSuccess(data));
  } catch (e) {
    yield put(getPersonalInfoFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* updatePersonalInfoSaga({ payload, callback }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/employee/update-personal-info`,
      payload,
    );
    yield put(updatePersonalInfoSuccess());
    yield put(successAlert("Personal info updated successfully!"));
    yield put(getPersonalInfoSuccess(data));
    if (callback) callback();
  } catch (e) {
    yield put(updatePersonalInfoFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while updating data!"));
  }
}

export function* getDocumentsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/employee/get-all-documents/${payload}`,
    );
    yield put(getDocumentsSuccess(data));
  } catch (e) {
    yield put(getDocumentsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* getHolidayInfoSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/employee/get-holiday-allocation/${payload}`,
    );
    yield put(getHolidayInfoSuccess(data));
  } catch (e) {
    yield put(getHolidayInfoFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* getLeavesSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/employee/get-leave-details-list/${payload}`,
    );
    yield put(getLeavesSuccess(data));
  } catch (e) {
    yield put(getLeavesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* updateHolidayInfoSaga({ payload, callback }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/employee/update-holiday-allocation`,
      payload,
    );
    yield put(updateHolidayInfoSuccess());
    yield put(successAlert("Time info updated successfully!"));
    if (callback) callback();
  } catch (e) {
    yield put(updateHolidayInfoFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while updating data!"));
  }
}

export function* getPayrollInfoSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/employee/get-payroll-info/${payload}`,
    );
    yield put(getPayrollInfoSuccess(data));
  } catch (e) {
    yield put(getPayrollInfoFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* updatePayrollInfoSaga({ payload, callback }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/employee/update-payroll-info`,
      payload,
    );
    yield put(updatePayrollInfoSuccess());
    yield put(successAlert("Payroll info updated successfully!"));
    if (callback) callback();
  } catch (e) {
    yield put(updatePayrollInfoFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while updating data!"));
  }
}

export function* downloadFileSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token, null, false, true).post,
      `/api/hr/onboarding/download-file`,
      payload.data,
    );
    if (data) {
      yield put(downloadFileSuccess());
      typeof onSuccess === "function" && onSuccess(data);
      const url = window.URL.createObjectURL(new Blob([data]));
      // const link = document.createElement("a");
      // link.href = url;
      // link.setAttribute("download", `${payload?.title}.${payload?.type}`);
      // document.body.appendChild(link);
      // link.click();
    }
  } catch (e) {
    yield put(downloadFileFailure());
    yield put(errorAlert(`Error while downloading file!`));
  }
}

export function* deleteFileSaga({ payload, callback }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).delete,
      `/api/hr-upload-document/${payload}`,
    );
    yield put(deleteFileSuccess());
    yield put(successAlert("File deleted successfully!"));
    typeof callback === "function" && callback();
  } catch (e) {
    yield put(deleteFileFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while deleting file!"));
  }
}

export function* getVersionHistorySaga({ payload, callback }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { field_id, employee_id } = payload;
  try {
    const { data } = yield call(
      api(token).get,
      `/api/hr/employee/${employee_id}/document-versions/${field_id}`,
    );
    yield put(getVersionHistorySuccess(data));
    typeof callback === "function" && callback(data);
  } catch (e) {
    yield put(getVersionHistoryFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching version history!"));
  }
}

export function* sendRevisionMailSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const basicInfo = yield select(
    (state) => state?.EmployeeEditReducer?.basicInfo,
  );
  const { type, employee_id } = payload;
  let apiConfig = {
    revision: `/api/hr/onboarding/revision-mail/${employee_id}`,
    review: `/api/hr/onboarding/final-hr-review-mail/${employee_id}`,
  };
  let messageConfig = {
    revision: "Revision mail sent successfully!",
    review: "Request for final approval sent successfully!",
  };
  try {
    const { data } = yield call(api(token).post, apiConfig[type], payload);
    yield put(sendRevisionMailSuccess());
    yield put(successAlert(messageConfig[type]));
    if (type === "review") {
      yield put(
        getBasicInfoSuccess({
          ...basicInfo,
          onboarding_status: "request for final review",
        }),
      );
    }
  } catch (e) {
    yield put(sendRevisionMailFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while sending revision mail!"));
  }
}

export function* getDocVersionsSaga({ payload, callback }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/employee-single-document-version-list`,
      payload,
    );
    yield put(getDocVersionsSuccess(data));
    typeof callback === "function" && callback(data);
  } catch (e) {
    yield put(getDocVersionsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching document versions!"));
  }
}

export function* sendDocMailSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/employee-common-document/correction-required-mail/${payload}`,
      payload,
    );
    yield put(sendDocMailSuccess());
    yield put(successAlert("Revision mail sent successfully!"));
  } catch (e) {
    yield put(sendDocMailFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while sending revision mail!"));
  }
}

export function* getDocCorrectionsSaga({ payload, callback }) {
  const token = process.env.REACT_APP_CUSTOMER_API_KEY;
  try {
    const { data } = yield call(
      api(token).get,
      `/api/employee/${payload}/correction-document-list`,
    );
    yield put(getDocCorrectionsSuccess(data));
    typeof callback === "function" && callback(data);
  } catch (e) {
    yield put(getDocCorrectionsFailure());
  }
}

export function* uploadNewDocSaga({ payload, callback }) {
  const token = process.env.REACT_APP_CUSTOMER_API_KEY;
  const { employeeId, formData } = payload;
  try {
    const { data } = yield call(
      api(token).post,
      `/api/employee/${employeeId}/update-correction-document`,
      formData,
    );
    yield put(uploadNewDocSuccess(data));
    yield put(successAlert("Document uploaded successfully!"));
    typeof callback === "function" && callback();
  } catch (e) {
    yield put(uploadNewDocFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while uploading document!"));
  }
}

export function* getStepHistorySaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = QueryString.stringify(payload);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/hr/onboarding/custom-step-history?${query}`,
    );
    yield put(getStepHistorySuccess(data));
  } catch (e) {
    yield put(getStepHistoryFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching step history!"));
  }
}

export function* getAdditionalDocumentsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/hr-upload-common-document/${payload}`,
    );
    yield put(getAdditionalDocumentsSuccess(data));
  } catch (e) {
    yield put(getAdditionalDocumentsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching additional documents!"));
  }
}

export function* getDocsHistorySaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/employee-doc-history/${payload}`,
    );
    yield put(getDocsHistorySuccess(data));
  } catch (e) {
    yield put(getDocsHistoryFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching document history!"));
  }
}

export function* editVersionFileSaga({ payload, callback }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/hr/onboarding/crop-update-file`,
      payload,
    );
    yield put(editVersionFileSuccess());
    yield put(successAlert("Document version updated successfully!"));
    if (callback) callback(data);
  } catch (e) {
    yield put(editVersionFileFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while updating document version!"));
  }
}

export function* getBasicInfoFlow() {
  yield takeEvery(GET_BASIC_INFO, getBasicInfoSaga);
}
export function* updateBasicInfoFlow() {
  yield takeEvery(UPDATE_BASIC_INFO, updateBasicInfoSaga);
}
export function* getUserAccountInfoFlow() {
  yield takeEvery(GET_USER_ACCOUNT_INFO, getUserAccountInfoSaga);
}
export function* updateUserAccountInfoFlow() {
  yield takeEvery(UPDATE_USER_ACCOUNT_INFO, updateUserAccountInfoSaga);
}
export function* getEmploymentInfoFlow() {
  yield takeEvery(GET_EMPLOYEEMENT_INFO, getEmploymentInfoSaga);
}
export function* updateEmploymentInfoFlow() {
  yield takeEvery(UPDATE_EMPLOYEEMENT_INFO, updateEmploymentInfoSaga);
}
export function* getPermissionsFlow() {
  yield takeEvery(GET_PERMISSIONS, getPermissionsSaga);
}
export function* updatePermissionsFlow() {
  yield takeEvery(UPDATE_PERMISSIONS, updatePermissionsSaga);
}
export function* getLineInfoFlow() {
  yield takeEvery(GET_LINE_INFO, getLineInfoSaga);
}
export function* updateLineInfoFlow() {
  yield takeEvery(UPDATE_LINE_INFO, updateLineInfoSaga);
}
export function* getWorkingInfoFlow() {
  yield takeEvery(GET_WORKING_INFO, getWorkingInfoSaga);
}
export function* updateWorkingInfoFlow() {
  yield takeEvery(UPDATE_WORKING_INFO, updateWorkingInfoSaga);
}
export function* getRoleInfoFlow() {
  yield takeEvery(GET_ROLE_INFO, getRoleInfoSaga);
}
export function* updateRoleInfoFlow() {
  yield takeEvery(UPDATE_ROLE_INFO, updateRoleInfoSaga);
}
export function* getWorkingLocationsFlow() {
  yield takeEvery(GET_WORKING_LOCATIONS, getWorkingLocationsSaga);
}
export function* updateLocationsFlow() {
  yield takeEvery(UPDATE_LOCATIONS, updateLocationsSaga);
}
export function* getOnboardingStepsFlow() {
  yield takeEvery(GET_ONBOARDING_STEPS, getOnboardingStepsSaga);
}
export function* getStepDetailsFlow() {
  yield takeEvery(GET_STEP_DETAILS, getStepDetailsSaga);
}
export function* approveFieldFlow() {
  yield takeEvery(APPROVE_FIELD, approveFieldSaga);
}
export function* getPersonalInfoFlow() {
  yield takeEvery(GET_PERSONAL_INFO, getPersonalInfoSaga);
}
export function* updatePersonalInfoFlow() {
  yield takeEvery(UPDATE_PERSONAL_INFO, updatePersonalInfoSaga);
}
export function* getDocumentsFlow() {
  yield takeEvery(GET_DOCUMENTS, getDocumentsSaga);
}
export function* getHolidayInfoFlow() {
  yield takeEvery(GET_HOLIDAY_INFO, getHolidayInfoSaga);
}
export function* getLeavesFlow() {
  yield takeEvery(GET_LEAVES, getLeavesSaga);
}
export function* updateHolidayInfoFlow() {
  yield takeEvery(UPDATE_HOLIDAY_INFO, updateHolidayInfoSaga);
}
export function* getPayrollInfoFlow() {
  yield takeEvery(GET_PAYROLL_INFO, getPayrollInfoSaga);
}
export function* updatePayrollInfoFlow() {
  yield takeEvery(UPDATE_PAYROLL_INFO, updatePayrollInfoSaga);
}
export function* downloadFileFlow() {
  yield takeEvery(DOWNLOAD_FILE, downloadFileSaga);
}
export function* deleteFileFlow() {
  yield takeEvery(DELETE_FILE, deleteFileSaga);
}
export function* getVersionHistoryFlow() {
  yield takeEvery(GET_VERSION_HISTORY, getVersionHistorySaga);
}
export function* sendRevisionMailFlow() {
  yield takeEvery(SEND_REVISION_MAIL, sendRevisionMailSaga);
}
export function* getDocVersionsFlow() {
  yield takeEvery(GET_DOC_VERSIONS, getDocVersionsSaga);
}
export function* sendDocMailFlow() {
  yield takeEvery(SEND_DOC_MAIL, sendDocMailSaga);
}
export function* getDocCorrectionsFlow() {
  yield takeEvery(GET_DOC_CORRECTIONS, getDocCorrectionsSaga);
}
export function* uploadNewDocFlow() {
  yield takeEvery(UPLOAD_NEW_DOC, uploadNewDocSaga);
}
export function* getStepHistoryFlow() {
  yield takeEvery(GET_STEP_HISTORY, getStepHistorySaga);
}
export function* getAdditionalDocumentsFlow() {
  yield takeEvery(GET_ADDITIONAL_DOCUMENTS, getAdditionalDocumentsSaga);
}
export function* getDocsHistoryFlow() {
  yield takeEvery(GET_DOCS_HISTORY, getDocsHistorySaga);
}
export function* editVersionFileFlow() {
  yield takeEvery(EDIT_VERSION_FILE, editVersionFileSaga);
}
export default function* EmployeeEditSaga() {
  yield all([
    getBasicInfoFlow(),
    updateBasicInfoFlow(),
    getUserAccountInfoFlow(),
    updateUserAccountInfoFlow(),
    getEmploymentInfoFlow(),
    updateEmploymentInfoFlow(),
    getPermissionsFlow(),
    updatePermissionsFlow(),
    getLineInfoFlow(),
    updateLineInfoFlow(),
    getWorkingInfoFlow(),
    updateWorkingInfoFlow(),
    getRoleInfoFlow(),
    updateRoleInfoFlow(),
    getWorkingLocationsFlow(),
    updateLocationsFlow(),
    getOnboardingStepsFlow(),
    getStepDetailsFlow(),
    approveFieldFlow(),
    getPersonalInfoFlow(),
    updatePersonalInfoFlow(),
    getDocumentsFlow(),
    getHolidayInfoFlow(),
    getLeavesFlow(),
    updateHolidayInfoFlow(),
    getPayrollInfoFlow(),
    updatePayrollInfoFlow(),
    downloadFileFlow(),
    deleteFileFlow(),
    getVersionHistoryFlow(),
    sendRevisionMailFlow(),
    getDocVersionsFlow(),
    sendDocMailFlow(),
    getDocCorrectionsFlow(),
    uploadNewDocFlow(),
    getStepHistoryFlow(),
    getAdditionalDocumentsFlow(),
    getDocsHistoryFlow(),
    editVersionFileFlow(),
  ]);
}
